import PageHero from "../components/PageHero";

function About() {
  return (
    <main>
      <PageHero
        title="About R&Do"
        text="R&Do Ltd. supports research, development, communication, digital transformation and exploitation strategies that help ideas become usable, visible and commercially meaningful."
      />

      <section className="section split">
        <div>
          <span className="eyebrow">Who we are</span>
          <h2>A partner for innovation with a route to market.</h2>
        </div>

        <p>
          R&Do, based in Cyprus, works with organisations, EU projects, research
          partnerships and private-sector stakeholders to design, develop,
          communicate and exploit innovative solutions. Our role is not limited
          to building digital tools or promoting project results. We help shape
          ideas into outcomes that can be adopted, scaled and sustained.
        </p>
      </section>

      <section className="section image-text">
        <img src="/images/about.jpg" alt="R&Do team and digital work" />

        <div>
          <span className="eyebrow">Our role</span>
          <h2>From research outcome to real-world opportunity.</h2>

          <p>
            Many strong ideas never reach the market because they remain too
            technical, too internal or too disconnected from user needs. R&Do
            works at that exact crossing point: where research, development,
            communication, market intelligence and commercialisation need to
            move together.
          </p>

          <p>
            We support the full journey: understanding the value of an idea,
            refining its positioning, designing the digital environment around
            it, communicating it effectively, managing knowledge and data, and
            connecting it with the right audiences, partners and opportunities.
          </p>
        </div>
      </section>

      <section className="section capabilities-section">
        <div className="section-heading">
          <span className="eyebrow">How we create value</span>
          <h2>One company, several connected disciplines.</h2>
        </div>

        <div className="capability-list">
          <article className="capability-item">
            <h3>Research & Development</h3>
            <p>
              We contribute to the design, development and improvement of
              digital products, platforms, services and project-based solutions.
            </p>
          </article>

          <article className="capability-item">
            <h3>Exploitation Planning</h3>
            <p>
              We help define how results can be used, scaled, transferred,
              commercialised or sustained after the initial development phase.
            </p>
          </article>

          <article className="capability-item">
            <h3>Communication & Dissemination</h3>
            <p>
              We create the strategies, messages, channels and campaigns that
              make complex ideas clear, visible and relevant to their audiences.
            </p>
          </article>

          <article className="capability-item">
            <h3>Marketing & Networking</h3>
            <p>
              We support outreach, partnerships, stakeholder engagement and
              market-facing activities that help solutions gain attention and
              credibility.
            </p>
          </article>

          <article className="capability-item">
            <h3>Digital Solutions</h3>
            <p>
              We design and deliver web platforms, digital learning
              environments, data-based tools, AI-ready services and integrated
              ICT solutions.
            </p>
          </article>

          <article className="capability-item">
            <h3>Data Management</h3>
            <p>
              We help organise, structure and use information so that projects
              and products can make better decisions and demonstrate stronger
              impact.
            </p>
          </article>
        </div>
      </section>

      <section className="section ipr-section">
        <div>
          <span className="eyebrow">IPR Management</span>
          <h2>Clear ownership creates stronger collaboration.</h2>
        </div>

        <div className="ipr-content">
          <p>
            Innovation often involves multiple partners: researchers,
            developers, companies, institutions, funders and commercial actors.
            When an idea becomes valuable, questions of ownership, rights,
            revenue, use and future development become critical.
          </p>

          <p>
            R&Do supports Intellectual Property Rights management by helping
            partnerships clarify how knowledge, technology, products and market
            opportunities can be handled fairly and strategically. This includes
            thinking about who owns what, how results may be used, how value may
            be shared and how intellectual rights can later support market
            rights.
          </p>

          <p>
            The goal is simple: reduce friction, protect the value of innovation
            and allow partners to move forward with confidence before success
            turns into confusion. Because nothing kills momentum faster than five
            partners discovering the word “ownership” at the worst possible
            moment.
          </p>
        </div>
      </section>

      <section className="section cards two">
        <article className="card large">
          <h3>Market-aware by design</h3>

          <p>
            We do not treat the market as an afterthought. From early concept to
            final communication, we look at user behaviour, technology trends,
            partner ecosystems, sector needs and commercial potential. This
            helps each solution become not only technically sound, but also
            relevant and desirable.
          </p>
        </article>

        <article className="card large">
          <h3>Built for lasting impact</h3>

          <p>
            Our work is shaped by sustainability, digital transformation,
            environmental awareness and long-term value creation. We are
            especially committed to projects and solutions connected with the
            blue economy, responsible innovation and meaningful European impact.
          </p>
        </article>
      </section>
    </main>
  );
}

export default About;